module.exports = __webpack_public_path__ + "static/media/profile1.80c043c8.jpg";